<template>
    <div class="myContern">
          <div class="u-min-width u-flex u-row-between u-col-top" >
                <div class="serverAdmin2Viewleft">
                    <ul>
                        <li :class="{'action':item.id==active}" v-for="(item,i) in dataList" :key="i" @click="selectData(item.id,i)" class="u-m-b-12">
                            <span class="span1 u-m-r-8" v-if="item.id==active" :style="{'background-position':item.set}"></span>
                            <span class="span2 u-m-r-8" v-else :style="{'background-position':item.set}"></span> 
                             {{item.name}}
                        </li>
                        
                    </ul>
                </div>
                <div class="serverAdmin2Viewright">
                    <div class="serverAdmin2Viewright-top">
                        <div>
                            <img src="../../assets/images/newImg/tubiao.png">
                            <span class="ConternTitle"> {{selectdata.Title}}</span>
                        </div>
                         <div class="Conternbtn"> <a style="color:#FFF;text-decoration: none;" href="https://www.oneboerp.com/new/productAdmin" target="_blank">免费试用</a></div>
                    </div>
                    <div class="serverAdmin2Viewright-view">
                         <ul class="u-flex  ERPShopAdminItem5-ul">
                            <li v-for="(item,i) in selectdata.List" :key="i" :style="{'border-right':(i+1)%3 !=0?'1px solid #F0F2F5':'none'}">
                                <div class="ul-img">
                                    <img :src="require('../../assets/images/Menu/1-'+item.num +'.png')">
                                </div>
                                <div class="ul-title1 u-m-t-10 u-m-b-10">{{item.name}}</div>
                                <div class="ul-title2">{{item.Title}}</div>
                            </li>
                           
                        </ul>
                         
                    </div>

                </div>
            </div>
    </div>
</template>
<script>
export default {
    name:'myContern',
    data(){
        return {
            active:1,
            dataList:[
                {
                   name:'刊登管理',
                   // background-position: -29px -15px; -29px -72px
                   set:"-29px -15px",
                   id:1,
                   Title:'同20+主流电商平台API无缝对接，刊登无需二次修改，刊登更快速、更便捷',
                   List:[
                     {
                        name:"多平台",
                        num:1,
                        Title:'支持OZON、Tik Tok、Shopee、Lazada等电商平台批量刊登'

                     },
                      {
                        name:"多店铺",
                        num:34,
                        Title:'多店铺一键刊登，1人轻松管千店 '
                     },
                     {
                        name:"数据搬迁",
                        num:3,
                        Title:'同平台店铺、不同平台店铺之间产品数据搬迁，无需二次修改 '
                     },
                     {
                        name:"批量采集刊登",
                        num:4,
                        Title:'产品批量采集，一件刊登快捷省时 '
                     },
                     {
                        name:"无需二次修改",
                        num:5,
                        Title:'ONEBO分销平台产品无缝刊登到任何电商平台，无需再次修改产品参数 '
                     },
                     {
                        name:"一键批量上架",
                        num:36,
                        Title:'采集箱的产品，可一键批量刊登上架至任意平台店铺 '
                     },
                   ],
                },
                 {
                   name:'选品管理',
                   set:'-29px -72px',
                   id:2,
                   Title:'智能多维工具支持，助你快速便捷选好爆品',
                   List:[
                      {
                        name:"选品便捷",
                         num:7,
                        Title:'深度链接ONEBO分销平台，一键选品采集'
                      },
                       {
                        name:"智能选品",
                         num:8,
                        Title:'实时抓取多平台爆款数据，支持大数据爆款选品推荐 '
                      },
                       {
                        name:"产品分析",
                         num:9,
                        Title:'提供热销产品、飙升产品、关键词等数据分析，为选品提供数据支撑'
                      },
                       {
                        name:"多维度选品分析",
                         num:10,
                        Title:'多平台新款、爆款、潜在爆款数据，销售数据分析'
                      },
                       {
                        name:"产品库丰富",
                         num:11,
                        Title:'智能批量管理产品，跨平台刊登无需重复编辑'
                      },
                       {
                        name:"自动化翻译",
                         num:12,
                        Title:'ONEBO分销平台支持图片智能多语言翻译'
                      },
                   ],
                },
                 {
                   name:'产品管理',
                   set:'-29px -133px',
                   id:3,
                   Title:'智能批量管理产品，跨平台刊登无需重复编辑',
                   List:[
                      {
                        name:"产品分级",
                         num:13,
                        Title:'提供爆款、旺款、平款、滞销款分类等级 '
                      },
                       {
                        name:"SKU数字化管理",
                         num:14,
                        Title:'多平台SKU库存统一管理，较全的店铺和产品数据库 '
                      },
                       {
                        name:"批量管理",
                         num:15,
                        Title:'支持批量产品上下架、改价格、改重量、改标题、添加水印、图片翻译等，一次到位不做重复工作 '
                      },
                       {
                        name:"产品数据化",
                         num:16,
                        Title:'管理所有产品信息，商品资料管理井井有条 '
                      },
                   ],
                },
                {
                   name:'订单管理',
                   set:'-29px -192px',
                   id:4,
                   Title:'订单自动拉取，智能采购，批量打单轻松快捷',
                   List:[
                      {
                        name:"集中订单处理",
                         num:17,
                        Title:'多平台多店铺订单集中式处理，订单信息集中管理 '
                      },
                       {
                        name:"自动打标签",
                         num:18,
                        Title:'根据订单来源自定义匹配渠道 '
                      },
                       {
                        name:"订单实时同步",
                         num:19,
                        Title:'订单采购后，自动获取物流运单号，实时物流信息同步至平台端 '
                      },
                       {
                        name:"订单批量管理",
                         num:20,
                        Title:'支持订单批量审核、修改、打单、发货，便捷管理 '
                      },
                   ],
                },
                {
                   name:'采购管理',
                   set:'-29px -252px',
                   id:5,
                   Title:'智能分析采购需求，合理管控整个采购流程，每一个环节都清晰明了',
                   List:[
                      {
                        name:"便捷采购",
                         num:21,
                        Title:'深度对接分销平台，丰富货源，满足各种生活场景需求 '
                      },
                       {
                        name:"批量采购",
                         num:22,
                        Title:'平台订单智能生成采购单，支持分销商城一键按需采购 '
                      },
                       {
                        name:"多平台采购管理",
                         num:23,
                        Title:'多平台订单智能采购，信息匹配精准无误 '
                      },
                       {
                        name:"采购单跟单管理",
                         num:24,
                        Title:'不同平台订单采购后，物流信息自动同步至各大平台，可实时追踪物流 '
                      },
                       {
                        name:"智能采购分析",
                         num:25,
                        Title:'提供采购数据报表分析，爆品、滞销品一目了然 '
                      },
                   ],
                },
                {
                   name:'分销管理',
                   set:'-29px -312px',
                   id:6,
                   Title:'一站式跨境分销管理，快捷分销，无成本压力',
                   List:[
                      {
                        name:"丰富产品SKU",
                         num:26,
                        Title:'海量一手工厂货源产品，跨境分销利润高 '
                      },
                       {
                        name:"选品数据分析",
                         num:27,
                        Title:'提供爆品分析、关键词排名分析等选品数据支撑 '
                      },
                       {
                        name:"一键刊登",
                         num:28,
                        Title:'分销平台海量产品，一键搬运至各大平台 '
                      },
                       {
                        name:"一件代发",
                         num:29,
                        Title:'分销商城产品全部支持一件代发，无需囤货，无资金压力 '
                      },
                       {
                        name:"定时刊登",
                         num:30,
                        Title:'定时上架，提高上架效率，规定时间下架，减少跟卖风险 '
                      },
                       {
                        name:"分销排名",
                         num:31,
                        Title:'销量排名监控，统计所有的分销数据以及商品的销量走势 '
                      },
                   ],
                },
                {
                   name:'财务管理',
                   set:'-29px -372px',
                   id:7,
                   Title:'智能化采购、订单等多维度财务数据报表，助力精准分析成本、利润',
                   List:[
                      {
                        name:"采购明细",
                         num:32,
                        Title:'采购成本统计，采购单价、总价等明细数据统计 '
                      },
                       {
                        name:"订单利润明细",
                         num:33,
                        Title:'精确分析SKU利润，让每一笔资金都清晰可见 '
                      },
                       {
                        name:"店铺利润明细",
                         num:34,
                        Title:'店铺、销售人员等多维度利润报表分析，助力店铺运营 '
                      },
                       {
                        name:"每日利润明细",
                         num:35,
                        Title:'多平台每日财务报表，快速及时掌握利润数据，优化业务流程 '
                      },
                   ],
                },
                {
                   name:'客户管理',
                   set:'-29px -432px',
                   id:8,
                   Title:'智能化客户信息收集，多平台客户轻松管理',
                   List:[
                      {
                        name:"客户分类",
                         num:36,
                        Title:'智能收集客户信息，贴标签 '
                      },
                       {
                        name:"客户标签",
                         num:37,
                        Title:'订单客户自动进行标签化，为店铺营销提供标签分析 '
                      },
                       {
                        name:"批量导入",
                         num:38,
                        Title:'支持批量导入客户信息，快捷省事 '
                      },
                       {
                        name:"智能机器人",
                         num:39,
                        Title:'机器人助手自动回复，高级群发 '
                      },
                       {
                        name:"多店铺同时处理",
                         num:40,
                        Title:'在ONEBO ERP后台可完成不同店铺的客服工作，清晰高效 '
                      },
                       {
                        name:"商业邮件群发",
                         num:41,
                        Title:'活动、节日等邮件批量群发，助力店铺营销 '
                      },
                   ],
                },
                {
                   name:'权限管理',
                   set:'-29px -492px',
                   id:9,
                   Title:'从团队到个人，分权限管理考核，提升整体绩效',
                   List:[
                      {
                        name:"多维度权限管理",
                         num:42,
                        Title:'自定义设置角色权限，可记录查询每位员工的操作行为 '
                      },
                       {
                        name:"员工管理",
                         num:43,
                        Title:'分架构进行团队管理，清晰每个部门的运营管理 '
                      },
                       {
                        name:"KPI考核",
                         num:44,
                        Title:'对每位人员进行KPI考核，统计所有工作人员的业绩，提高企业整体绩效 '
                      },
                       {
                        name:"团队绩效管理",
                         num:45,
                        Title:'清晰呈现团队绩效管理，产出投入及占比分析，助力经营决策 '
                      },
                      
                   ],
                },
            ],


            selectdata: {
                   name:'刊登管理',
                   id:1,
                   Title:'同20+主流跨境平台API无缝对接，刊登无需二次修改，刊登更快速、更便捷',
                   List:[
                      {
                        name:"多平台",
                        num:1,
                        Title:'支持OZON、Tik Tok、shopee、lazada等跨境电商平台批量刊登'

                     },
                      {
                        name:"多店铺",
                        num:34,
                        Title:'多店铺一键刊登，1人轻松管千店 '
                     },
                     {
                        name:"数据搬迁",
                        num:3,
                        Title:'同平台店铺、不同平台店铺之间产品数据搬迁，无需二次修改 '
                     },
                     {
                        name:"批量采集刊登",
                        num:4,
                        Title:'产品批量采集，一件刊登快捷省时 '
                     },
                     {
                        name:"无需二次修改",
                        num:5,
                        Title:'ONEBO分销平台产品无缝刊登到任何跨境平台，无需再次修改产品参数 '
                     },
                     {
                        name:"一键批量上架",
                        num:36,
                        Title:'采集箱的产品，可一键批量刊登上架至任意平台店铺 '
                     },
                   ],
                },
        }
    },
   methods:{
      selectData(id,index){
         this.active=id;
         this.selectdata=this.dataList[index]
      }
   }
}
</script>
<style lang="scss" scoped>
      .myContern{
         padding-bottom: 80px;
        
         .serverAdmin2Viewleft{
            width: 260px;
            height: 570px;
            background: #FFFFFF;
            box-shadow: 0px 3px 20px 1px rgba(0,0,0,0.06);
            border-radius: 8px;
            ul{
                padding: 20px 0px;
                li{
                  padding: 0 35px;
                  height: 48px;
                  line-height: 48px;
                  font-size: 16px;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #101111;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  & span{
                    display: inline-block;
                    width: 18px;
                    height: 20px;
                  }
                  .span1{
                      background: url('../../assets/images/newImg/Mune1.png');
                     
                  }
                   .span2{
                      background: url('../../assets/images/newImg/Mune2.png');
                  }
                }
                .action{
                    background: #FEF4EC;
                    color: #FD681C;
                }
            }
            .serverAdmin2Viewleftfoot{
                border-top: 1px solid #D1D0D3;
                .serverAdmin2Viewleft-Title{
                     padding: 0 35px;
                     height: 48px;
                    line-height: 48px;
                    font-size: 16px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #101111;
                }
                .serverAdmin2Viewleft-Virew{
                    padding: 0 35px;
                    & div:nth-child(1){
                        font-size: 14px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        margin: 10px 0 20px;
                    }
                     & div:nth-child(2){
                        background: #FD681C;
                        font-size: 14px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFF;
                        padding: 10px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }
         }
         .serverAdmin2Viewright{
            width: 1136px;
            background: #FFFFFF;
            box-shadow: 0px 3px 20px 1px rgba(0,0,0,0.06);
            border-radius: 8px;
            overflow: hidden;
            .serverAdmin2Viewright-top{
                background: url("../../assets/images/newImg/myconter.png");
                height: 190px;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items:flex-start;
                font-size: 16px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #777777;
                padding-left: 30px;
                .ConternTitle{
                    position: relative;
                    bottom: 20px;
                    margin-left: -40px;
                    font-size: 20px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #4E5968;
                }
                .Conternbtn{
                    width: 152px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: #FD681C;
                    border-radius: 21px 21px 21px 21px;
                    font-size: 16px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFF;
                    margin-left: 40px;
                    margin-top: 20px;
                    cursor: pointer;
                }
            }
            .serverAdmin2Viewright-view{
                display: flex;
                flex-wrap: wrap;
                  .ERPShopAdminItem5-ul{
                     background: #FFF;
                     flex-wrap: wrap;
                    & li{
                        width: calc(33.33% - 52px);
                        padding:15px 25px 35px 25px;
                     
                        &:nth-child(1){
                             border-bottom: 1px solid #F0F2F5;
                        }
                        &:nth-child(2){
                             border-bottom: 1px solid #F0F2F5;
                        }
                        &:nth-child(3){
                             border-bottom: 1px solid #F0F2F5;
                        }
                        .ul-img{
                            width: 40px;
                            height: 38px;
                           
                        }
                        .ul-title1{
                            font-size: 16px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                        }
                        .ul-title2{
                            font-size: 14px;
                            font-family: PingFang SC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #9898A4;
                            height: 60px;
                        }
                    }
           
            
           
        }
            }
         }
       }
</style>